import { KYMW6600Model } from '../kymw6600.model';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';


/**
 * 特別指示書画面　特別指示書を取得するサービス
 *
 * @export GetIndicationListService
 * @class GetIndicationList
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetIndicationListService extends PlessJsonResponderSub<any> {

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW6600Model}
   * @memberof GetIndicationListService
   */
  private model: KYMW6600Model;

  vo = {
    indicationDiv: '',
    orderCode: '',
    classCode: '',
    mediumType: '',
    buyerCode: '',
  };

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof GetIndicationListService
   */
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetIndicationListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        IndicationDiv: this.vo.indicationDiv,
        OrderCode: this.vo.orderCode,
        ClassCode: this.vo.classCode,
        MediumType: this.vo.mediumType,
        BuyerCode: this.vo.buyerCode
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetIndicationListService
   */
  execute(model: KYMW6600Model, vo: any, successFunc: Function = null): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('getIndicationList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetIndicationListService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
